import Vue from 'vue';

export default {
    state:{
      tareas:{
       
      }
    },
    mutations: {
      
    },
    actions: { 
      postCSS({ }, payload) {
        try {
          $("#" + payload.id)
            .append(
              `<style>${payload.style}</style>`
            );
        } catch (error) {
  
        }
      },
    },
    getters: {  
      
    },
    
}


// WEBPACK FOOTER //
// ./src/modules/tareas.js